import { render, staticRenderFns } from "./MenuEdition.vue?vue&type=template&id=1c5f6aa4&scoped=true&"
import script from "./MenuEdition.vue?vue&type=script&lang=js&"
export * from "./MenuEdition.vue?vue&type=script&lang=js&"
import style0 from "./MenuEdition.vue?vue&type=style&index=0&id=1c5f6aa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f6aa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c5f6aa4')) {
      api.createRecord('1c5f6aa4', component.options)
    } else {
      api.reload('1c5f6aa4', component.options)
    }
    module.hot.accept("./MenuEdition.vue?vue&type=template&id=1c5f6aa4&scoped=true&", function () {
      api.rerender('1c5f6aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Menus/MenuEdition.vue"
export default component.exports